import { BrowsersIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Browse = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <BrowsersIcon {...rest} size={Sizes[size]} color={fill} />;
};

Browse.displayName = 'Browse';
